import { z } from 'zod';

export const PlaceIdSchema = z.string();
export type PlaceId = z.infer<typeof PlaceIdSchema>;

export const GeoLocationSchema = z
  .object({
    latitude: z.number(),
    longitude: z.number()
  })
  .optional();

export type GeoLocation = z.infer<typeof GeoLocationSchema>;
